import React from 'react'


function AddCustomer() {
  return (
    <div>
      <h3>AddCustomer</h3>
      
    </div>
  )
}

export default AddCustomer